<template>
    <!--    分类管理dialog-->
    <div>
        <el-dialog :close-on-click-modal="false"   class="manage-dialog"  width="500px" title="管理分类" :visible.sync="classManageDialog" :before-close="beforeClose">
            <edit-tree></edit-tree>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import editTree from '../common/editTree'
    export default {
        name: "ClassManage",
        props:["classManageDialog"],
        components:{editTree},
        data(){
            return{

            }
        },
        methods:{
            beforeClose:function(){
                this.$emit('closeCMDialog_z');
            },
            submit:function () {
                this.$emit('closeCMDialog_z');
            }
        }
    }
</script>

<style scoped>
    .manage-dialog .el-dialog__header,.manage-dialog .el-dialog__body,.manage-dialog .el-dialog__footer{ padding: 10px 20px !important;}
</style>
